import styled from "styled-components";
import { Variables } from "../../styles/Variables";

export const Modal = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 12px;
  width: 120px;
  height: 30px;
  background-color: ${Variables.colorWhite};
  box-shadow: 5px 5px 5px 4px rgba(0, 0, 0, 0.2);
  border: 1px solid #000;
`;

export const Select = styled.select`
  width: 100%;
  height: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  border: 2px solid ${Variables.colorOrange};
  border-radius: 10px;
`;

export const OptionSelect = styled.option`
  text-align: center;
  font-size: 14px;
  font-weight: 600;
`;
